const searchOrderList = ($ordersEle, $noResultEle, $searchInput) => {
    const $orders = $ordersEle?.dataset?.products ? JSON.parse($ordersEle.dataset.products) : [];

    $searchInput?.addEventListener('input', (e) => {
        let value = e.target.value.toLowerCase();
        let index = 0;

        Array.prototype.forEach.call($orders,($order) => {
            const $el = document.getElementById(`product-${$order.id}`);

            if ($order.name.toLowerCase().includes(value)
                || $order.productNumber.includes(value)
                || $order.shortDescription.toLowerCase().includes(value)
                || $order.customOrderNumber.toLowerCase().includes(value)) {
                $el?.classList.remove('hidden');
            } else {
                $el?.classList.add('hidden');
                index++;

                if (index === $orders.length) {
                    $noResultEle?.classList.remove('hidden');
                } else {
                    $noResultEle?.classList.add('hidden');
                }
            }
        });
    });
};


(() => {
    const $ordersEle = document.body.querySelector('.sm-quick-order__products-list');
    const $noResultEle = document.body.querySelector('.sm-quick-order__no-result-container');
    const $searchInput = document.body.querySelector('.sm-quick-order__search-container .header-search-input');

    searchOrderList($ordersEle, $noResultEle, $searchInput);
})();
